import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga'

import moment from 'moment';
import { socialIcons } from '../../../styles/icons';
import RelevanceCard from './comment-toggle/RelevanceCard';
import SarcasmTogglingCard from './comment-toggle/SarcasmTogglingCard';
import { 
  NO_SPECIFIC_EMOTION_PILL_CLASS,
  NO_SPECIFIC_EMOTION ,
  SARCASTIC_PILL_CLASS,
  NOT_SARCASTIC_PILL_CLASS,
  SARCASTIC_LABEL,
  NOT_SARCASTIC_LABEL,
  SARCASM_CONFIDENCE_SCORE_HOVER_TEXT,
  SARCASM_MANUALLY_TOGGLED_HOVER_TEXT,
  MARKED_AS_IRRELEVANT_LABEL,
  E_PLUS_TWO,
  E_MINUS_TWO
} from '../redux/constants';
import { IS_SARCASM_ENABLED, SARCASM_THRESHOLD_PERCENTAGE } from '../../../common/globalConstants';

const maxTweetStringLength = 135;

export class Tweet extends Component {
  static propTypes = {
    userTweet: PropTypes.object.isRequired,
    updateRelevance: PropTypes.func.isRequired,
    updateTweetsIsSarcasmManuallyToggled: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired,
    allTopicKeywords: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      userTweet: {
        isTranslated: false,
        tweetInOriginalLanguage: "",
        tweet: "",
        source: "",
        sentiment: {
          category: ""
        },
        emotion: {
          category: ""
        },
        sarcasm: {
          score: 0
        }
      },
      isSeeMore: false,
      isEllipsisActive: false,
      allTopicKeywords: []
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    const userTweet = this.props.userTweet;
    this.setState({
      userTweet: userTweet
    });
    this._updateAllTopicKeywordsStateIfNewAllTopicKeywords(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      userTweet: nextProps.userTweet
    });
    this._updateAllTopicKeywordsStateIfNewAllTopicKeywords(nextProps);
  }

  _updateAllTopicKeywordsStateIfNewAllTopicKeywords(nextProps) {
    if (nextProps.allTopicKeywords && this.state.allTopicKeywords !== nextProps.allTopicKeywords) {
      this.setState({ allTopicKeywords: nextProps.allTopicKeywords });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  toggleSeeMore = isSeeMore => {
    ReactGA.event(
      {
        category : 'Tweets' ,
        action : `User with id ${this.props.cookies.userMeta} was redirected to see more about ${this.props.userTweet} from ${this.state.userTweet.source}`
      }
    )
    this.setState({isSeeMore});
  }

  _getTweetCSSName = () => {
    const {userTweet} = this.state;
    return userTweet.source.toLowerCase().replace(/\s+/g, '_');
  }

  _returnEmotionPillClass = () => {
    const {userTweet} = this.state;
    const userEmotion = userTweet.emotion.category
    if (userEmotion === NO_SPECIFIC_EMOTION) {
      return NO_SPECIFIC_EMOTION_PILL_CLASS
    } else {
      return userEmotion
    }
  }

  _returnSarcasmPillClass = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {userTweet} = this.state;
    const isSarcasmManuallyToggled = userTweet.sarcasm.isSarcasmManuallyToggled;
    const sarcasmScorePercentageFormatRounded = this._returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces(userTweet.sarcasm.score);
    if (sarcasmScorePercentageFormatRounded >= SARCASM_THRESHOLD_PERCENTAGE) {
      if (!isSarcasmManuallyToggled) {
        return SARCASTIC_PILL_CLASS;
      }
      else {
        return NOT_SARCASTIC_PILL_CLASS;
      }
    }
    else if (sarcasmScorePercentageFormatRounded >= 0) {
      if (!isSarcasmManuallyToggled) {
        return NOT_SARCASTIC_PILL_CLASS;
      }
      else {
        return SARCASTIC_PILL_CLASS;
      }
    }
    return '';
  }
  
  _returnSarcasmPillText = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {userTweet} = this.state;
    const isSarcasmManuallyToggled = userTweet.sarcasm.isSarcasmManuallyToggled;
    const sarcasmScorePercentageFormatRounded = this._returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces(userTweet.sarcasm.score);
    if (sarcasmScorePercentageFormatRounded >= SARCASM_THRESHOLD_PERCENTAGE) {
      if (!isSarcasmManuallyToggled) {
        return `${SARCASTIC_LABEL} (${sarcasmScorePercentageFormatRounded}%)`;
      }
      else {
        return `${NOT_SARCASTIC_LABEL}`;
      }
      
    }
    else if (sarcasmScorePercentageFormatRounded >= 0) {
      if (!isSarcasmManuallyToggled) {
        return `${NOT_SARCASTIC_LABEL} (${sarcasmScorePercentageFormatRounded}%)`;
      }
      else {
        return `${SARCASTIC_LABEL}`;
      }
      
    }
    return '';
  }

  _returnSarcasmPillHoverText = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {userTweet} = this.state;
    if (userTweet.sarcasm.isSarcasmManuallyToggled) {
      return SARCASM_MANUALLY_TOGGLED_HOVER_TEXT;
    }
    else {
      const sarcasmScorePercentageFormatRounded = this._returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces(userTweet.sarcasm.score);
      return `${SARCASM_CONFIDENCE_SCORE_HOVER_TEXT} ${sarcasmScorePercentageFormatRounded}%`;
    }
  }

  _returnSarcasmScoreRoundedToMaximumTwoDecimalPlaces = (sarcasmScore) => {
    const sarcasmScorePercentageFormat = sarcasmScore * 100;
    const sarcasmScorePercentageFormatRounded = +(Math.round(parseFloat(sarcasmScorePercentageFormat + E_PLUS_TWO)) + E_MINUS_TWO);
    return sarcasmScorePercentageFormatRounded;
  }

  _returnShouldSarcasmFeaturesBeShown = () => {
    const {userTweet} = this.state;
    return (IS_SARCASM_ENABLED && userTweet.sarcasm.score >= 0);
  }

  toggleIfEllipsisIsActive= () => {
    this.setState(prevState => {
      return { isEllipsisActive: !prevState.isEllipsisActive };
    });
  
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isEllipsisActive: false });
    }
  }

  updateRelevanceInRelevanceCard = tweetId => {
    const { updateRelevance } = this.props;
    updateRelevance(tweetId);
    this.setState({
      isEllipsisActive: false
    });
  }

  updateIsSarcasmManuallyToggledInDropdown = tweetId => {
    const { updateTweetsIsSarcasmManuallyToggled } = this.props;
    updateTweetsIsSarcasmManuallyToggled(tweetId);
    this.setState({
      isEllipsisActive: false
    });
  }

  _convertTweetTextToInnerHTMLWithHighlightedKeywords = (tweetText) => {
    let updatedTweetText      = tweetText;
    const {allTopicKeywords} = this.state;
    allTopicKeywords.sort((a,b) => b.length - a.length);
    for (let keyword of allTopicKeywords) {
      let myRegexp = new RegExp(`(^|[^a-zA-Z0-9])(${keyword})([^a-zA-Z0-9]|$)`,'mig');
      updatedTweetText = updatedTweetText.replace(
        myRegexp,
        '$1<span style="background-color: yellow;">$2</span>$3'
      );
    }
    return updatedTweetText;
  }

  renderOriginalLanguageOfTweetIfItIsTranslated(userTweet,isSeeMore){
    return userTweet.isTranslated && (
      <div className='original-non-english'>
        <div className='vertical-line'/>
        <div className="content">
            <a href={userTweet.sourceLink} target="_blank">
              <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`}
                 dangerouslySetInnerHTML={{ __html: this._convertTweetTextToInnerHTMLWithHighlightedKeywords(userTweet.tweetInOriginalLanguage)}}
              />
            </a>
            {userTweet.tweetInOriginalLanguage.length > maxTweetStringLength && !isSeeMore ? (
              <span className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                <u>See More</u>
              </span>
            ) : (
              userTweet.tweetInOriginalLanguage.length > maxTweetStringLength &&
              isSeeMore && (
                <span className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                  See Less
                </span>
              )
            )}
        </div>
    </div>
    )
  }

  render() {
    const { 
      userTweet,
      isSeeMore,
      isEllipsisActive
    } = this.state;
    const tweetCSSName = this._getTweetCSSName();
    const emotionPillClass = this._returnEmotionPillClass();
    const shouldSarcasmFeaturesBeShown = this._returnShouldSarcasmFeaturesBeShown();
    const sarcasmPillText  = this._returnSarcasmPillText();
    const sarcasmPillClass = this._returnSarcasmPillClass();
    const sarcasmPillHoverText = this._returnSarcasmPillHoverText();
    return (
        <div className="comment-card">
          <div className="header">
            <div 
              className="category"
              ref={this.wrapperRef}
            >
              <div
                className={`social-button card-header-button ${tweetCSSName}`}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: socialIcons[tweetCSSName],
                  }}
                />
              </div>
              <div className="card-header-button">
                {userTweet.sentiment.category && (
                  <button className={`btn-positive ${userTweet.sentiment.category}`}>
                    {userTweet.sentiment.category}
                  </button>
                )}
              </div>
                {userTweet.emotion.category && (
                    <div className="card-header-button">
                      {userTweet.emotion.category && (
                        <button className={`btn-emotion ${emotionPillClass}`}>
                          {userTweet.emotion.category}
                        </button>
                      )}
                    </div>
                  )}

                <div className="card-header-button">
                  {shouldSarcasmFeaturesBeShown &&
                    (
                      <button 
                        className={`btn-emotion ${sarcasmPillClass}`}
                        title={sarcasmPillHoverText}
                      >
                        {sarcasmPillText} 
                        {userTweet.sarcasm.isSarcasmManuallyToggled ? <i className="las la-user-edit icon"></i> : ''}
                      </button>
                  )}
                </div>
                <div 
                  className={`ellipsis ${isEllipsisActive ? 'active' : ''}`}
                  onClick={() => this.toggleIfEllipsisIsActive()} 
                >
                  <i className="la la-ellipsis-v"></i>
                </div>
                {isEllipsisActive && (
                  <div className="comments-toggle default-toggle-card-margin">
                    <RelevanceCard
                      userCommentOrPost={this.props.userTweet}
                      updateRelevance={e => this.updateRelevanceInRelevanceCard(e)}
                      commentOrPostId={String(this.props.userTweet.tweetId)}
                    />
                    {shouldSarcasmFeaturesBeShown && (
                      <SarcasmTogglingCard
                        userComment={this.props.userTweet}
                        updateIsSarcasmManuallyToggled={e => this.updateIsSarcasmManuallyToggledInDropdown(e)}
                        commentId={String(this.props.userTweet.tweetId)}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          <div className="content">
            <a href={userTweet.sourceLink} target="_blank">
              <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`}
                 dangerouslySetInnerHTML={{ __html: this._convertTweetTextToInnerHTMLWithHighlightedKeywords(userTweet.tweet) }}
              />
            </a>
            {userTweet.tweet.length > maxTweetStringLength && !isSeeMore ? (
              <span className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                <u>See More</u>
              </span>
            ) : (
              userTweet.tweet.length > maxTweetStringLength &&
              isSeeMore && (
                <span className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                  See Less
                </span>
              )
            )}
          </div>
          {this.renderOriginalLanguageOfTweetIfItIsTranslated(userTweet,isSeeMore)}
          <div className={`card-header-bottom ${!userTweet.relevance ? 'card-header-bottom-space-between' : ''}`}>
              {!userTweet.relevance && (
                <div className="card-header-irrelevant">{MARKED_AS_IRRELEVANT_LABEL}</div>
              )}
              <label>{moment(userTweet.datetime).format('DD MMM YYYY hh:mm A')}</label>
          </div>
        </div>
      )
  }
}

export default Tweet;



// WEBPACK FOOTER //
// ./src/features/home/components/Tweet.js